export const CLEVERTAP_KEYS = {
    ONE_PLAN_PURCHASED: "One Plan Purchased",
    IRCTC_PAYMENT_VISIT: "IRCTC Payment Visit",
    IRCTC_ORDER_CONFIRM: "IRCTC Order Confirm",
};
